import React, { useMemo } from 'react';

import { useHomeownerTranslate } from '../../hooks';
import type { DesignerPaintProduct } from '../../types';

import type { PaintColorPalette } from './ColorPaletteCard';
import { ColorPaletteCard } from './ColorPaletteCard';
import {
  SelectPaletteSheet,
  type SelectPaletteSheetLoadingProps,
  type SelectPaletteSheetProps,
} from './SelectPaletteSheet';
import { buildPalettes } from './utils';

export interface PaintColorPaletteSheetProps
  extends Omit<SelectPaletteSheetProps, 'children'>,
    SelectPaletteSheetLoadingProps {
  paintColors: DesignerPaintProduct[];
}

interface PlaceholderPaintColorPalette extends PaintColorPalette {
  isLoading: true;
}

export const PaintColorPaletteSheet = ({
  isLoading = false,
  paintColors,
  placeholderCount = 10,
  ...props
}: PaintColorPaletteSheetProps) => {
  const t = useHomeownerTranslate();
  const loadingText = t('customize.skeletonLoading');

  const placeholders = useMemo(
    () =>
      Array.from(
        { length: placeholderCount },
        (): PlaceholderPaintColorPalette => ({
          name: loadingText,
          colors: [],
          isLoading: true,
        }),
      ),
    [loadingText, placeholderCount],
  );

  const palettes = useMemo(() => buildPalettes(paintColors), [paintColors]);

  const mergedProps = { ...props, isLoading };

  return (
    <SelectPaletteSheet {...mergedProps}>
      {(isLoading ? placeholders : palettes).map((palette, i) => (
        <ColorPaletteCard
          isLoading={'isLoading' in palette}
          key={'isLoading' in palette ? i : palette.name}
          palette={palette}
        />
      ))}
    </SelectPaletteSheet>
  );
};
